module.exports = __webpack_public_path__ + "static/CV-2175d99fa9e0f382b53fa61aedc2b27f.pdf";